import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { SERVICES } from "@/data/urban";

export const ServicesSection = () => (
  <section id="services" className="py-20 md:py-28 bg-canvas">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
      <div className="max-w-2xl">
        <Reveal><div className="overline text-ink-soft">Services</div></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-tight">Everything You Need for Your Home</h2>
        </Reveal>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => (
          <motion.div key={s.key}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
            className="group relative overflow-hidden rounded-2xl bg-white border border-hairline">
            <div className="aspect-[4/3] overflow-hidden bg-canvas">
              <img src={s.img} alt={s.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="p-6">
              <h3 className="font-heading text-lg font-bold text-ink">{s.title}</h3>
              <p className="mt-1.5 text-sm text-ink-soft">{s.desc}</p>
              {s.price && <p className="mt-1 text-sm font-semibold text-ink">{s.price}</p>}
              <div className="mt-4 flex items-center gap-3">
                <Link to={s.href} className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-ink hover:opacity-70">View Details <ArrowUpRight className="h-3.5 w-3.5" /></Link>
                <span className="text-hairline">·</span>
                <Link to="/contact" className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-ink hover:opacity-70">Get Quote</Link>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
